import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "yrf_token";
const REFRESH_KEY = "yrf_refresh";
export function setToken(t) { if (t) localStorage.setItem(TOKEN_KEY, t); }
export function setRefreshToken(t) { if (t) localStorage.setItem(REFRESH_KEY, t); }
export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function getRefreshToken() { return localStorage.getItem(REFRESH_KEY); }
export function clearToken() { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(REFRESH_KEY); }

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach bearer token as a fallback to cookies (browsers may block 3rd-party cookies).
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Silent session refresh: on a 401, call /auth/refresh once (cookie or stored refresh
// token), update the bearer token, and retry the original request. Single-flight so
// concurrent 401s trigger only one refresh. Never weakens auth — the backend still
// validates token_version.
let refreshPromise = null;
async function doRefresh() {
  const rt = getRefreshToken();
  const { data } = await axios.post(`${API}/auth/refresh`, rt ? { refresh_token: rt } : {}, { withCredentials: true });
  if (data?.access_token) setToken(data.access_token);
  if (data?.refresh_token) setRefreshToken(data.refresh_token);
  return data?.access_token;
}
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const status = error.response?.status;
    const url = cfg?.url || "";
    const isAuthPath = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/register");
    const hadAuth = getToken() || getRefreshToken();
    if (status === 401 && cfg && !cfg._retried && !isAuthPath && hadAuth) {
      cfg._retried = true;
      try {
        if (!refreshPromise) refreshPromise = doRefresh().finally(() => { refreshPromise = null; });
        const newToken = await refreshPromise;
        if (newToken) cfg.headers = { ...cfg.headers, Authorization: `Bearer ${newToken}` };
        return api(cfg);
      } catch (e) {
        clearToken();
      }
    }
    return Promise.reject(error);
  }
);

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return path;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
